import { useQuery } from '@tanstack/react-query';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import {
  DOC_TYPE_ANNOTATION,
  ENTITY_TYPE_DOCUMENTATION,
} from '@internal/plugin-neo4j-techdocs-common';

export const DOC_TYPE_COUNTS_QUERY_KEY = 'docTypeCounts' as const;

const DOC_TYPE_FACET = `metadata.annotations.${DOC_TYPE_ANNOTATION}`;

/** Use the category page's catalog filter so that each count matches its doc list. */
export function useDocTypeCounts() {
  const catalogApi = useApi(catalogApiRef);

  return useQuery({
    queryKey: [DOC_TYPE_COUNTS_QUERY_KEY],
    queryFn: () =>
      catalogApi.getEntityFacets({
        filter: { kind: 'component', 'spec.type': ENTITY_TYPE_DOCUMENTATION },
        facets: [DOC_TYPE_FACET],
      }),
    select: ({ facets }): Record<string, number> =>
      Object.fromEntries(
        (facets[DOC_TYPE_FACET] ?? []).map(({ value, count }) => [
          value,
          count,
        ]),
      ),
  });
}
